module.exports = __webpack_public_path__ + "static/service-1-47955942557dfa1bbbcc09d1a5b3cbc7.png";